var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-dialer-common-page",
      class: { "only-content": !_vm.showHeader },
    },
    [
      _vm.showHeader
        ? _c("div", { staticClass: "header" }, [
            _c(
              "div",
              {
                staticClass: "icon-button is-mobile",
                class: { "is-disabled": _vm.isDisabled },
                attrs: { "data-action": "go-back" },
                on: { click: _vm.onGoBack },
              },
              [_c("or-icon", { attrs: { icon: "arrow_back" } })],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "title" }, [
              _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }